export default __webpack_public_path__ + "static/media/refsign-logo.94c22a48.svg";